import {CxEvent} from '@spartacus/core';

export class EddlLogoutEvent extends CxEvent {
  static readonly type = 'EddlLogoutEvent';
}
